<div id="leftSideButtonHolder">
  <div id="zoom"></div>
  <div id="navigation"></div>
  <div id="compass"></div>
  <div id="home"></div>
  <div id="locate"></div>
  <app-drag-zoom></app-drag-zoom>
  <app-previous-extent></app-previous-extent>
</div>
<div #mapViewNode></div>
<app-coordinate></app-coordinate>
<router-outlet></router-outlet>
